/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link as RouterLink, Navigate } from "react-router-dom";
import { Alert, Box, Button, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const API = "https://api.besteurogirls.com";
const TOKEN_KEY = "beg_model_token";
const RED = "#d4163c";
const getToken = (): string => { try { return window.localStorage.getItem(TOKEN_KEY) || ""; } catch (e) { return ""; } };

export const fieldSx = {
  backgroundColor: "transparent !important",
  background: "transparent !important",
  "& .MuiInputBase-root, & .MuiInputBase-root input": { backgroundClip: "padding-box" },
  "& .MuiInputBase-input": { backgroundColor: "transparent !important", color: "#fff", colorScheme: "dark" },
  "& .MuiInputLabel-root": { color: "rgba(255,255,255,.65)" },
  "& .MuiInputLabel-root.Mui-focused": { color: "#fff" },
  "& .MuiFormLabel-asterisk": { color: RED },
  "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus": {
    WebkitTextFillColor: "#fff", caretColor: "#fff", WebkitBoxShadow: "0 0 0 100px #1a1a20 inset", transition: "background-color 9999s ease-out 0s",
  },
  "& .MuiOutlinedInput-root": {
    color: "#fff",
    backgroundColor: "transparent !important",
    borderRadius: "10px",
    "& fieldset": { borderColor: "rgba(255,255,255,.28)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,.55)" },
    "&.Mui-focused fieldset": { borderColor: "rgba(255,255,255,.8)", borderWidth: 1 },
  },
  "& .MuiSvgIcon-root": { color: "rgba(255,255,255,.8)" },
};

export const LoginPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [forgot, setForgot] = useState(false);
  const [sent, setSent] = useState("");

  useEffect(() => {
    const prev = document.title;
    document.title = "Login | Best Euro Girls";
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex";
    document.head.appendChild(m);
    return () => {
      document.title = prev;
      m.remove();
    };
  }, []);

  if (getToken()) return <Navigate to="/account" replace />;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const res = await fetch(API + "/auth/login/user", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), password }),
      });
      const data: any = await res.json().catch(() => ({}));
      if (res.ok && data.token) {
        window.localStorage.setItem(TOKEN_KEY, data.token);
        window.location.href = "/account";
        return;
      }
      setErr(res.status >= 500 ? "Could not log in. Try again in a minute." : "Wrong email or password.");
    } catch (ex) {
      setErr("Could not log in. Check your connection and try again.");
    }
    setBusy(false);
  };

  const sendLink = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const res = await fetch(API + "/public/password/forgot", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data: any = await res.json().catch(() => ({}));
      if (res.ok) setSent(data.message || "If that email has an account, we have sent a link to reset the password.");
      else setErr("Could not send the email. Try again in a minute.");
    } catch (ex) {
      setErr("Could not send the email. Check your connection and try again.");
    }
    setBusy(false);
  };

  if (forgot) {
    return (
      <Box sx={{ maxWidth: 420, mx: "auto", py: { xs: 3, md: 5 }, color: "#e8e8ec" }}>
        <Box sx={{ backgroundColor: "#1a1a20", border: "1px solid rgba(255,255,255,.08)", borderRadius: 2, p: { xs: 2.5, md: 3.5 } }}>
          <Typography component="h1" sx={{ color: "#fff", fontSize: { xs: 28, md: 32 }, fontWeight: 600, mb: 1 }}>
            Reset password
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,.7)", mb: 2.5, fontSize: 15 }}>
            Enter the email of your account and we will send you a link to choose a new password.
          </Typography>
          {sent ? (
            <Alert severity="success" sx={{ mb: 2 }}>{sent}</Alert>
          ) : (
            <Box component="form" onSubmit={sendLink} noValidate sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <TextField label="Your email" type="email" required value={email} sx={fieldSx}
                inputProps={{ maxLength: 150, autoComplete: "email" }} onChange={(e) => setEmail(e.target.value)} />
              {err && <Alert severity="error">{err}</Alert>}
              <Button type="submit" variant="contained" size="large" disabled={busy || !email.trim()}
                sx={{ backgroundColor: RED, fontWeight: 700, letterSpacing: ".06em", borderRadius: "10px", py: 1.25, "&:hover": { backgroundColor: "#a8102f" }, "&.Mui-disabled": { backgroundColor: "rgba(212,22,60,.35)", color: "rgba(255,255,255,.6)" } }}>
                {busy ? "Please wait..." : "SEND LINK"}
              </Button>
            </Box>
          )}
          <Button onClick={() => { setForgot(false); setSent(""); setErr(""); }} sx={{ mt: 1, color: "rgba(255,255,255,.75)", textTransform: "none", textDecoration: "underline", px: 0, minWidth: 0 }}>
            Back to login
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 420, mx: "auto", py: { xs: 3, md: 5 }, color: "#e8e8ec" }}>
      <Box sx={{ backgroundColor: "#1a1a20", border: "1px solid rgba(255,255,255,.08)", borderRadius: 2, p: { xs: 2.5, md: 3.5 } }}>
        <Typography component="h1" sx={{ color: "#fff", fontSize: { xs: 30, md: 36 }, fontWeight: 600, mb: 2.5 }}>
          Login
        </Typography>
        <Box component="form" onSubmit={submit} noValidate sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField label="Your email" type="email" required value={email} sx={fieldSx}
            inputProps={{ maxLength: 150, autoComplete: "email" }} onChange={(e) => setEmail(e.target.value)} />
          <TextField label="Password" type={show ? "text" : "password"} required value={password} sx={fieldSx}
            inputProps={{ maxLength: 100, autoComplete: "current-password" }} onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label="Show or hide password" onClick={() => setShow(!show)} onMouseDown={(ev) => ev.preventDefault()} edge="end" sx={{ color: "rgba(255,255,255,.7)" }}>
                    {show ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }} />
          {err && <Alert severity="error">{err}</Alert>}
          <Button type="submit" variant="contained" size="large" disabled={busy || !email.trim() || !password}
            sx={{ backgroundColor: RED, fontWeight: 700, letterSpacing: ".06em", borderRadius: "10px", py: 1.25, "&:hover": { backgroundColor: "#a8102f" }, "&.Mui-disabled": { backgroundColor: "rgba(212,22,60,.35)", color: "rgba(255,255,255,.6)" } }}>
            {busy ? "Please wait..." : "LOGIN"}
          </Button>
          <Button onClick={() => { setForgot(true); setErr(""); }} sx={{ alignSelf: "flex-start", color: "rgba(255,255,255,.75)", textTransform: "none", textDecoration: "underline", px: 0, minWidth: 0 }}>
            Lost password?
          </Button>
        </Box>
        <Box sx={{ borderTop: "1px solid rgba(255,255,255,.08)", mt: 3, pt: 3 }}>
          <Typography component="h2" sx={{ color: "#fff", fontSize: { xs: 24, md: 28 }, fontWeight: 600, mb: 2 }}>
            New user?
          </Typography>
          <Button component={RouterLink} to="/account?mode=register" variant="outlined" fullWidth size="large"
            sx={{ color: "#fff", borderColor: RED, fontWeight: 700, letterSpacing: ".06em", borderRadius: "10px", py: 1.25, "&:hover": { borderColor: RED, backgroundColor: "rgba(212,22,60,.12)" } }}>
            CREATE ACCOUNT
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
